$(document).ready(function () {
    function tabSwitching() {
        $('.tab_btn').on('click', function () {
            let parent = $(this).closest('.tab-section');
            parent.find('.tab-btn').removeClass('active');
            parent.find('.tab-content').css({
                'display': 'none'
            })

            $(this).addClass('active');
            parent.find('.tab-content[id="' + $(this).attr('data-tab-content-id') + '"]').css({
                'display': 'block'
            })
        })
    }

    tabSwitching();

    if ($('.BabyPelones__carousel2').length) {
        $('.BabyPelones__carousel2').slick(
            {
                slidesToShow: 4,
                //autoplay: true,
                slidesToScroll: 1,
                //variableWidth: true,
                infinite: true,
                speed: 700,
                autoplaySpeed: 7000,
                arrows: false,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1.02,
                            arrows: false,
                            dots: true,
                            infinite: false,
                            // variableWidth: false
                        }
                    }
                ]
            }
        );
    }

    if ($('.BabyPelones__carousel3').length) {
        $('.BabyPelones__carousel3').slick(
            {
                slidesToShow: 4,
                //autoplay: true,
                slidesToScroll: 1,
                infinite: true,
                speed: 700,
                autoplaySpeed: 7000,
                arrows: false,
                rows: 0,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 3,
                            arrows: false
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1.02,
                            arrows: false,
                            dots: true,
                            infinite: false,
                            // variableWidth: false
                        }
                    }
                ]
            }
        );
    }
});
